/**
 * @description Ajout dynamique du data-icon
 * @param target élément ciblé
 * @param nameIcon nom de l'icon
 * @param multipleTarget Boolean: si true => querySelectorAll de l'élément target, sinon =>querySelector
 *
 */

const addIcon = (target, nameIcon, multipleTarget) => {
	if (multipleTarget === '') {
		multipleTarget = false;
	}
	let targetEl;
	if (multipleTarget) {
		targetEl = document.querySelectorAll(target);
		targetEl.forEach((el) => {
			el.setAttribute('data-icon', nameIcon);
		});
	} else {
		document.querySelector(target).setAttribute('data-icon', nameIcon);
	}
};

/**
 * @description Permet de cibler les characters/mots souhaités pour leur appliquer une classe
 * @param word mot ciblé
 * @param classWord class a ajouter
 */

const styleDate = (word, classWord) => {
	const card = document.querySelectorAll('.homepage__events__card');
	card.forEach((item) => {
		const dateTag = item.querySelector('div:first-child');
		if (dateTag.innerHTML.indexOf(word) > -1) {
			dateTag.innerHTML = dateTag.innerHTML.replace(
				word,
				'<span class="' + classWord + '">' + word + '</span>'
			);
		}
	});
};

/**
 * @description Gestion hauteur background image homepage
 */

const bgShape = () => {
	const overlay = document.querySelector('.homepage__shortcuts__overlay');
	const heightShortcuts = document.querySelector('.homepage__shortcuts')
		.offsetHeight;
	const eventCard =
		document.querySelector('.homepage__events__card:first-child') || null;
	if (eventCard) {
		const heightCard = eventCard.offsetHeight;
		const overlayHeight = heightShortcuts + heightCard + 30;
		overlay.style.height = overlayHeight + 'px';
	}
};

const init = () => {
	styleDate('Du', 'fw-500');
	styleDate('au', 'fw-500');
	styleDate('Le', 'fw-500');
	bgShape();
	addIcon('.homepage__events__card .address', 'localisation', true);
};

init();
